/**
 * @type {Object}
 * @property {array}  data  Item data
 */
const initialState = {
    deliveryChargesData: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerDeliveryCharges = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_DELIVERY_CHARGES':
            var { data } = action;
            newState.deliveryChargesData = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerDeliveryCharges;